import React, { useEffect, useRef, useState } from 'react';
import styles from './FlowNavigator.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import { useBrandingContext } from 'app-context/BrandingsContext';
import { useWorkflowContext } from 'app-context/worflow/WorkflowContext';

const FlowNavigator = ({ handleAddNode }) => {
  const dropdownRefs = useRef([]);
  const { brandingData } = useBrandingContext();
  const { setType } = useWorkflowContext();
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const [hoverIndex, setHoverIndex] = useState(null);

  const navigatorData = [
    {
      parent: 'AI',
      children: [
        {
          label: 'Response Ai',
          iconType: 'ai-chat',
          type: 'responseAINode',
          nodeType: 1,
        },
        {
          label: 'Data Ai',
          iconType: 'data-ai',
          type: 'dataAINode',
          nodeType: 14,
        },
      ],
    },
    {
      parent: 'Talk',
      children: [
        {
          label: 'Message',
          iconType: 'message',
          type: 'messageNode',
          nodeType: 2,
        },

        { label: 'Image', iconType: 'image', type: 'imageNode', nodeType: 3 },
        { label: 'Video', iconType: 'video', type: 'videoNode', nodeType: 4 },
        {
          label: 'Document',
          iconType: 'document',
          type: 'documentNode',
          nodeType: 5,
        },
        {
          label: 'Carousel',
          iconType: 'carousel',
          type: 'carouselNode',
          nodeType: 7,
        },
      ],
    },
    {
      parent: 'Listen',
      children: [
        {
          label: 'Capture',
          iconType: 'node-capture',
          type: 'captureNode',
          nodeType: 8,
        },
        // {
        //   label: 'Question',
        //   iconType: 'node-question',
        //   type: 'questionNode',
        //   nodeType: 9,
        // },
        { label: 'Form', iconType: 'form', type: 'formNode', nodeType: 6 },
      ],
    },
    {
      parent: 'Logic',
      children: [
        {
          label: 'Condition',
          iconType: 'node-if',
          type: 'conditionNode',
          nodeType: 10,
        },
      ],
    },
    {
      parent: 'Dev',
      children: [
        {
          label: 'System',
          iconType: 'system',
          type: 'systemNode',
          nodeType: 13,
        },
        {
          label: 'API',
          iconType: 'api',
          type: 'apiNode',
          nodeType: 14,
        },
        {
          label: 'Get Data',
          iconType: 'get-data',
          type: 'getDataNode',
          nodeType: 15,
        },
      ],
    },
    {
      parent: 'Whatsapp',
      children: [
        {
          label: 'Send Message',
          iconType: 'message',
          type: 'sendMessageNode',
          nodeType: 11,
        },
        {
          label: 'Send Email',
          iconType: 'message',
          type: 'sendEmailNode',
          nodeType: 12,
        },
      ],
    },
  ];

  const handleClick = (child) => {
    setActiveDropdown(null);
    setActiveIndex(null);
    setHoverIndex(null);
    handleAddNode(child);
  };
  const handleDropdownToggle = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index);
    setActiveIndex(index);
  };

  const handleClickOutside = (event) => {
    if (
      dropdownRefs.current.every((ref) => ref && !ref.contains(event.target))
    ) {
      setActiveDropdown(null);
      setActiveIndex(null);
    }
  };
  const onDragStart = (event, nodeType) => {
    setType(nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={styles['flow-navigator']}>
      {navigatorData?.map((item, index) => (
        <div
          key={index}
          className={styles['navigate-item']}
          ref={(el) => (dropdownRefs.current[index] = el)}
          onClick={() => handleDropdownToggle(index)}
          onMouseEnter={() => {
            if (activeIndex !== index) {
              setActiveDropdown(index);
              setActiveIndex(index);
            }
            setHoverIndex(index);
          }}
          onMouseLeave={() => {
            setHoverIndex(null);
            setActiveDropdown(null);
            setActiveIndex(null);
          }}
        >
          <div
            className={`${styles['button-wrapper']} ${
              activeIndex === index ? styles['active'] : ''
            }`}
          >
            <SvgWithBranding
              type={item.parent.toLowerCase()}
              className={styles.svg}
              color={
                activeIndex === index || hoverIndex === index
                  ? brandingData.page_ButtonColor
                  : ''
              }
            />

            <p
              style={{
                color:
                  activeIndex === index || hoverIndex === index
                    ? brandingData.page_ButtonColor
                    : '',
              }}
            >
              {item.parent}
            </p>
          </div>
          <div
            className={`${styles['dropdown']} ${
              activeDropdown === index || hoverIndex === index
                ? styles.opened
                : styles.closed
            }`}
          >
            <ul>
              {item.children?.map((child, i) => (
                <li
                  key={i}
                  className={
                    child.isBordered
                      ? styles['bordered']
                      : styles['none-bordered']
                  }
                  onClick={() => handleClick(child)}
                  onDragStart={(event) => onDragStart(event, child.nodeType)}
                  draggable
                >
                  <SvgWithBranding
                    type={child.iconType}
                    className={styles.icon}
                  />
                  <p>{child.label}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FlowNavigator;
